export function isGameConfirmationButtonDisabled(eventStore) {
  const hasUnresolvedScoreAdjustmentEvents = (eventStore ?? []).some(
    (event) =>
      event.eventType === "scoreAdjustment" && event.status !== "deleted"
  );

  return hasUnresolvedScoreAdjustmentEvents;
}
